import React from 'react'
import CommentBlock from './CommentBlock'

const CommentList = ({ comments }) => {
  return (
    <div className='commentsBlock__list'>
        {
			comments && comments.length > 0 ?
				comments.map((comment) => {
					return (
						<CommentBlock
                            key={comment.id}
							comment={comment}
						/>
					)
				})
			: 
				<div>
					Коментарів не знайдено
				</div>
		}
    </div>
  )
}

export default CommentList